import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/program/front/git/ams/node_modules/_@babel_runtime-corejs2@7.28.3@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TagsView from '@/layout/components/TagsView/index';
import * as DICTION from '@/utils/diction';
export default {
  name: 'Topbar',
  components: {
    TagsView: TagsView
  },
  computed: {
    fixedHeader: function fixedHeader() {
      return this.$store.state.settings.fixedHeader;
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    unit: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isShow: false,
      title: ''
    };
  },
  created: function created() {
    var url = window.location.host;
    this.title = DICTION.CONFIG_TITLE[url] ? DICTION.CONFIG_TITLE[url] : DICTION.DEFALUT_TITLE;
  },
  methods: {
    logout: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return this.$store.dispatch('user/logout');
            case 1:
              this.$router.push("/login");
              this.$store.state.tagsView.visitedViews = [];
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};